module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding@2x-3449a27d6aee78a077a2a90a45697963.webp";